import { render, staticRenderFns } from "./purchasingSummaryWidget.vue?vue&type=template&id=b4dff93e&"
import script from "./purchasingSummaryWidget.vue?vue&type=script&lang=js&"
export * from "./purchasingSummaryWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports